import React from 'react';

const logo = '/logo.jpeg';

export default function AppLoader({ size = 64 }) {
  const containerStyle = {
    position: 'relative',
    width: `${size}px`,
    height: `${size}px`,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  };

  const spinnerStyle = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    border: `${Math.max(2, size / 16)}px solid #e8eaf6`,
    borderTopColor: '#1a237e',
    borderRadius: '50%',
    animation: 'ritika-loader-spin 1.2s infinite linear',
  };

  const logoStyle = {
    width: '60%',
    height: '60%',
    objectFit: 'contain',
    borderRadius: '50%',
    animation: 'ritika-logo-pulse 1.6s ease-in-out infinite',
    zIndex: 1,
  };

  return (
    <div className="flex justify-center items-center p-4 w-full h-full">
      <div style={containerStyle} aria-label="Loading" role="status">
        <div style={spinnerStyle}></div>
        <img src={logo} alt="Loading..." style={logoStyle} />
      </div>
    </div>
  );
}
